import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-integration-review',
  templateUrl: './integration-review.component.html',
  styleUrls: ['./integration-review.component.scss'],
})
export class IntegrationReviewComponent implements OnChanges{
  @Input() youtubeReviewLink: string = '';
  @Input() youtubeReviewTitle: string = '';

  protected safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnChanges() {
    if (this.youtubeReviewLink) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.youtubeReviewLink);
    }
  }
}
